// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2271":"1c4aac7a","3530":"937645c0","5046":"1c4aac7a","5931":"55dbb6f7","5959":"55dbb6f7","8412":"408ff266","8574":"408ff266"}[chunkId] + ".chunk.css";
};